import { Col } from "reactstrap";
import CommonTourSocialMedia from "../Common/CommonTourSocialMedia";

export const FifthStyleSocialMedia = () => {
  return (
    <Col sm="4" className="align-self-center mt-0 text-end">
      <CommonTourSocialMedia time="2 Yours ago" className="step9" />
    </Col>
  );
};
